export default function checkParams(params: string[]): boolean {
  const { search } = window.location;
  if (!search) {
    return false;
  }
  const searchParams = new URLSearchParams(search);
  return params.reduce((acc: boolean, nextParam: string): boolean => {
    const paramValue = searchParams.get(nextParam);
    return acc || paramValue == 'true';
  }, false);
}
